import { getCdnAssetInfo } from '../ReachApiV1';

export async function getVideoAssetUrl(assetUuid: string, mimeType = 'video/mp4'): Promise<string> {
    const response = await getCdnAssetInfo(assetUuid);
    const assets = response.assets.filter(function (asset) {
        return asset.type === mimeType;
    });
    if (assets.length < 1) {
        throw ReferenceError(`No '${mimeType}' asset exists for '${assetUuid}'`);
    }
    return assets[0].redirect;
}
